<template>
    <div class="container full d-flex justify-content-center align-items-center">
        <b-link class="back" to="/translate"><svg-icon icon="back" /></b-link>
        <LoadingSpinner v-if="loading" />
        <template v-else>
            
            <validation-observer ref="observer" v-slot="{handleSubmit}">
                <b-form class="signin" @submit.stop.prevent="handleSubmit(login)">
                    <img :src="`/img/${$store.state.site.id}/logo.svg`" alt="Logo" />
                    <h1>{{ $t('signInAccount')}}</h1>
                        <validation-provider :name="$t('email')" rules="email|required" v-slot="validationContext">
                            <b-form-group :label="$t('email')" label-for="email" label-sr-only>
                                <b-form-input id="email" name="email" type="email" :placeholder="$t('email')" v-model="form.email" :state="getValidationState(validationContext)" autofocus @input="updateEmail"></b-form-input>
                                <b-form-invalid-feedback id="email-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider v-if="isIdentityUser === false" :name="$t('password')" rules="required" v-slot="validationContext">
                            <b-form-group :label="$t('password')" label-for="password" label-sr-only>
                                <b-form-input id="password" name="password" type="password" :placeholder="$t('password')" v-model="form.password" :state="getValidationState(validationContext)" @input="updateInput"></b-form-input>
                                <b-form-invalid-feedback id="password-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                        <template v-if="msg">
                            <p id="general-message" class="invalid-feedback d-block">{{ msg }}</p>
                        </template>
                        <div v-if="isIdentityUser === false" class="d-flex justify-content-end mb-3">
                            <a class="signin__forgot ml-auto" :href="$store.state.site.platformUrl + '/password/reset#/'"><small>{{ $t('forgotPassword') }}</small></a>
                        </div>
                        <b-button class="mt-3 p-3" variant="primary" type="submit" block>{{ $t(isIdentityUser === false ? 'signIn' : 'continue') }}</b-button>
                    
                </b-form>
            </validation-observer>
        </template>
    </div>
</template>
<script>

import { ValidationObserver, ValidationProvider } from "vee-validate";
import SvgIcon from '@/components/SvgIcon'
import AuthService from '../services/AuthService.js';
import LoadingSpinner from '@/components/loader/Loader';
import { clearCourseCaches } from '@/common/auth';
import { startIdentityLogin } from '@/common/identity';

export default {
    name: 'LoginScreen',
    data() {
        return {
            msg: null,
            loading: false,
            isIdentityUser: null,
            form: {
                email: '',
                password: ''
            }
        }
    },
    mounted() {
        this.$store.dispatch('setMaintenanceMode', [false]);
        if (this.$route.query.expired === '1') {
            this.msg = this.$t('sessionExpiredText');

        }
    },
    beforeDestroy() {
        this.identityLogin?.cancel();
    },
    components: {
        ValidationObserver,
        ValidationProvider,
        SvgIcon,
        LoadingSpinner
    },
    methods: {
        updateEmail() {
            this.isIdentityUser = null;
            this.form.password = '';
            this.updateInput();
        },
        updateInput() {
            this.msg = null;
            if (this.$route.query.expired === '1') {
                this.$router.replace({ query: {} }).catch(() => {});
            }
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        async login() {
            this.msg = null;
            this.loading = true;
            try {
                if (this.isIdentityUser === null) {
                    const result = await AuthService.checkEmail(this.form.email);
                    if (typeof result?.is_identity_user !== 'boolean') {
                        throw new Error(this.$t('UnableToLogin'));
                    }
                    this.isIdentityUser = result.is_identity_user;
                    if (!this.isIdentityUser) {
                        this.loading = false;
                        return;
                    }
                }
                let response;
                if (this.isIdentityUser) {
                    this.identityLogin = startIdentityLogin(this.$store.state.site.platformUrl, this.form.email);
                    response = await this.identityLogin.promise;
                } else {
                    response = await AuthService.login(this.form);
                }
                const token = response.token;
                const user = response.user;
                await clearCourseCaches();
                this.$store.dispatch('login', { token, user });
                this.$router.push('/');
            } catch (error) {
                this.loading = false;
                if (error?.code === 'login_cancelled') {
                    this.msg = this.$t('loginCancelled');
                    return;
                }
                this.msg = this.isIdentityUser === false && error?.message
                    ? error.message : this.$t('UnableToLogin');
            }
        }
    }
}
</script>
